/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// @mui material components
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';

function RoleCheck({ checkList, checkValue, setValue }) {
  const [checked, setChecked] = useState([...checkValue]);

  const handleToggle = (chk, value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    // console.log(newChecked);
    setChecked(newChecked);
    setValue(value, chk);
  };

  return (
    <MDBox>
      <TableContainer sx={{ boxShadow: 0, border: '1px solid #f2f2f2' }}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableBody>
            {checkList.map((row) => (
              <TableRow key={row.id}>
                <TableCell width={200}>{row.name}</TableCell>
                <TableCell>
                  <FormGroup aria-label='position' row>
                    {row.sub.map((item) => (
                      <FormControlLabel
                        key={item.id}
                        control={
                          <Switch
                            color='info'
                            tabIndex={-1}
                            checked={checked.indexOf(item.id) !== -1}
                            onClick={(e) => handleToggle(e.target.checked, item.id)}
                            // onChange={(e) => setValue(e.target.checked)}
                          />
                        }
                        label={item.name}
                        sx={{ marginRight: 3 }}
                      />
                    ))}
                  </FormGroup>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </MDBox>
  );
}

RoleCheck.propTypes = {
  checkList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  checkValue: PropTypes.arrayOf(PropTypes.string).isRequired,
  setValue: PropTypes.func.isRequired,
};

export default RoleCheck;
